"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
function AudioButton(props) {
    const { onClick, disabled = false } = props;
    const onHandleClick = () => {
        onClick();
    };
    return ((0, jsx_runtime_1.jsx)(ui_1.ToolBarBaseButton, Object.assign({}, props, { onClick: onHandleClick, disabled: disabled, "$flashOnClick": true, "data-e2e": 'AudioButton_ToolBarBaseButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Audio, width: 24, height: 24, "data-e2e": 'AudioButton_Icon' }) })));
}
exports.default = AudioButton;
